import React from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { Stack, Typography } from '@mui/material';
import { createSx } from '@ui-lib/utils';
import { EBOL_STATUS } from '../../../../../../api/types/EbolStatus';
import { ebolStatusBackgroundColors, ebolStatusLabels } from './const';
import { getIcon } from './utils';

const sx = createSx({
  container: {
    borderRadius: 1,
    padding: 2,
    my: 1,
  },
});
interface Props {
  status: EBOL_STATUS;
  updated_at: string;
};

const BolStatus = ({ status, updated_at }: Props) => {
  const { t } = useTranslation();

  const Icon = getIcon(status);
  return (
    <Stack
      sx={sx.container}
      bgcolor={ebolStatusBackgroundColors[status]}
      direction={'row'}
      spacing={2}>
      {Icon}
      <Stack>
        <Typography variant='body2Bold' data-test-id='ebol-status'>
          {t(ebolStatusLabels[status])}
        </Typography>
        <Typography variant='body2' data-test-id='ebol-last-updated'>
          {moment(updated_at).utc().format('MMM D, YYYY [at] HH:mm [UTC]')}
        </Typography>
      </Stack>
    </Stack>
  );
};

export default BolStatus;